import { Button, Gradient, LogoIcon, StarsIcon } from '@cfs-fixings/shared'
import { Link, Outlet, useMatch } from 'react-router-dom'

const textSpecs = {
  links: {
    signIn: 'Sign In',
    signUp: 'Join the beta',
  },
  menu: {
    about: 'About',
    platform: 'Platform',
    features: 'Features',
  },
}

function PublicRouteTemplate () {
  const isLogin = Boolean(useMatch('/'))

  return (
    <div className="w-full h-screen flex">
      {
        !isLogin && (
          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            {/* Gradient */}
            <div className="absolute bottom-[-402px] left-[-421px]">
              <Gradient className="w-[1118px] h-[735px]" />
            </div>

            {/* Stars */}
            <div className="absolute bottom-[45px] right-[-256px] hidden md:block">
              <StarsIcon className="w-[713px] h-[535px]" />
            </div>
          </div>
        )
      }

      {/* Outlet */}
      <div className="z-10 w-full h-full flex">
        <Outlet />
      </div>

      {/* Navbar */}
      <div className="absolute inset-x-[30px] top-[23px] flex justify-between items-center z-20">
        <div className="flex items-center gap-[63px]">
          <Link to="/">
            <LogoIcon className="w-[93px] h-[45px]" />
          </Link>

          {
            !isLogin && (
              <ul className="gap-[48px] font-semibold hidden md:flex">
                <li>
                  <Link to="https://clariti.site/" target="_blank">
                    {textSpecs.menu.about}
                  </Link>
                </li>
                <li>
                  <Link to="https://clariti.site/#platform" target="_blank">
                    {textSpecs.menu.platform}
                  </Link>
                </li>
                <li>
                  <Link to="https://clariti.site/#features" target="_blank">
                    {textSpecs.menu.features}
                  </Link>
                </li>
              </ul>
            )
          }
        </div>

        <div className="flex items-center gap-[16px]">
          <Link to="/">
            <p className="font-semibold text-gray-900 relative">
              {textSpecs.links.signIn}

              {
                isLogin
                && <span className="absolute -bottom-[6px] left-[50%] translate-x-[-50%] h-[2px] bg-gray-900 w-[16px]" />
              }
            </p>
          </Link>

          <Link to="/signup">
            <Button
              variant="primary"
              size="md"
            >
              {textSpecs.links.signUp}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PublicRouteTemplate
